<mat-toolbar class="background-color-green" style=" position: sticky; top: 0;  z-index: 7;">   
    <a [routerLink]="" (click)="backClicked()">
        <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="arrow_back" style="padding-top:9px; margin-right:10px; color:white;"></mat-icon>
    </a>       
    <span class="text-color-white">{{ 'ml_143975' | translate }}</span>
    <span class="text-color-white" style="margin-left: 6px;" *ngIf="browserLangToUse.includes('zh')"> ( {{ apexId }} )</span>
    <span class="example-spacer"></span>
    <mat-select hideSingleSelectionIndicator class="select-custom" 
        [ngStyle]="{'width': browserLangToUse.toLowerCase().includes('zh') ? '90px' : '150px'}"
        [(value)]="selectedMonth" (selectionChange)="setMonthAndYearFromSelect($event.value)">
        @for (month of monthArray; track month) {
            <mat-option style="font-size: 12px;" [value]="month.textValue">{{month.textString}}</mat-option>
        }
    </mat-select>
</mat-toolbar>

<div *ngIf="isLoading" class="center">
    <mat-spinner class="example-margin" [color]="color"></mat-spinner>
</div>

<div *ngIf="!isLoading">
    <mat-list>
        @if(kpiCategoryScoreRankingArray?.length === 0){
            <span class="text-color-blue" style="font-size: 20px; margin-left: 10px;">{{ 'ml_151232' | translate }}</span>
        }
        @else {
            
                <mat-list-item>            
                    <span class="font-weight-600 text-color-blue">{{ 'ml_143969' | translate }}</span>            
                </mat-list-item>                       
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title class="font-weight-600 text-color-green flex-basis-200px">
                            <span  *ngIf="!isYear">{{ 'ml_144034' | translate }}: </span>
                            <span  *ngIf="isYear">{{ 'ml_144045' | translate }}: </span>                                  
                        </mat-panel-title>
                        <mat-panel-description>
                            <div *ngIf="!isYear">
                                <span class="text-color-blue" style="font-weight: 600; font-size: 16px;">{{monthActualScore === 0 ? '-' : monthActualScore.toFixed(1)}}</span>
                                <span>/{{monthTotalScore === 0 ? '-' : monthTotalScore}}</span>
                            </div>   
                            <div *ngIf="isYear">
                                <span class="text-color-blue" style="font-weight: 600; font-size: 16px;">{{yearAverageScore === 0 ? '-' : yearAverageScore.toFixed(1)}}</span>
                                <span>/100</span>
                            </div>             
                            
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                        <div style="display: flex; flex-direction: row; align-items: center; height: 40px;" *ngIf="isYear">
                            <mat-panel-title class="font-weight-600 text-color-green flex-basis-200px">
                                <span class="font-weight-600 text-color-green" >{{ 'ml_151120' | translate }}: </span>                               
                            </mat-panel-title>
                            <mat-panel-description>
                                
                                <div class="text-color-blue"  style="padding-right: 4px;" >
                                    <span style="font-weight: 600; font-size: 16px;">{{yearActualScore}}</span>
                                    <span>/{{yearTotalScore}}</span>
                                </div>
                            </mat-panel-description>
                        </div>    
                        
                        
                        
                        @for (kpiCategoryScore of kpiCategoryScoreRankingArray; track kpiCategoryScore) {                                    
                            <mat-expansion-panel hideToggle disabled>                        
                                <mat-expansion-panel-header style="color: rgba(0,0,0,0.86); ">
                                    <mat-panel-title class="flex-basis-200px text-color-green" style="color: #009947;">                                
                                        {{ kpiCategoryScore.translation_Id  | translate }}
                                    </mat-panel-title>
                                    <mat-panel-description class="text-color-blue" style="color: #00BFFF;">
                                        <span class="example-spacer"></span>
                                        {{kpiCategoryScore.kpiCategoryItems?.length === 0 ? '-' : kpiCategoryScore.kpiCategoryItems[0].score}}
                                    </mat-panel-description>
                                </mat-expansion-panel-header>                            
                            </mat-expansion-panel>                    
                        }
                </mat-expansion-panel>        
            
        
            
                <mat-list-item>            
                    <span class="font-weight-600 text-color-blue">{{ 'ml_144046' | translate }}</span>            
                </mat-list-item>
                <div class="example-button-row-padding">
                    @for (categoryRanking of categoryRankingArray; track categoryRanking) {                
                        <div class="example-button-row">                    
                            <!-- <span style="display: block; width: 90px; text-align: center; height: 40px;" class="text-color-green">{{ categoryRanking.subtitle.toString() | translate }}</span> -->
                            <circle-progress
                                [percent]="categoryRanking.percent"                            
                                [radius]="35"
                                [space]="-10"
                                [outerStrokeGradient]="true"
                                [outerStrokeWidth]="10"
                                [outerStrokeColor]="categoryRanking.outerStrokeColor"
                                [outerStrokeGradientStopColor]="categoryRanking.outerStrokeGradientStopColor"
                                [innerStrokeColor]="'#e7e8ea'"
                                [innerStrokeWidth]="10"
                                [title]= "categoryRanking.title"
                                [showSubtitle]="false"
                                [animateTitle]="false"
                                [animationDuration]="0"
                                [animation]="false"
                                [showUnits]="false"
                                [showBackground]="false"
                                [clockwise]="false"
                                [startFromZero]="false"
                                [lazy]="false" 
                            ></circle-progress>
                            <span style="display: block;  text-align: center; height: 40px; width: 90px;" class="text-color-green">{{ categoryRanking.subtitle.toString() | translate }}</span>
                        </div>                
                    }
                </div>                        
             
    
            
                <mat-list-item>            
                    <span class="font-weight-600 text-color-blue">{{ 'ml_144037' | translate }}</span>
                </mat-list-item>
                <div class="example-button-row-padding">
                    @for (overallRanking of overallRankingArray; track overallRanking) {                
                        <div class="example-button-row">
                            <circle-progress
                            [percent]="overallRanking.percent"                        
                            [radius]="overallRanking.radius"
                            [space]="-10"
                            [outerStrokeGradient]="true"
                            [outerStrokeWidth]="10"
                            [outerStrokeColor]="overallRanking.outerStrokeColor"
                            [outerStrokeGradientStopColor]="overallRanking.outerStrokeGradientStopColor"
                            [innerStrokeColor]="'#e7e8ea'"
                            [innerStrokeWidth]="10"
                            [title]= "overallRanking.title"
                            [showSubtitle]="false"
                            [animateTitle]="false"
                            [animationDuration]="0"
                            [animation]="false"
                            [showUnits]="false"
                            [showBackground]="false"
                            [clockwise]="false"
                            [startFromZero]="false"
                            [lazy]="false"
                        ></circle-progress>
                        <span [style.width.px]="overallRanking.radius*2+20" style="display: block;  text-align: center; height: 40px;" class="text-color-green">{{ overallRanking.subtitle.toString() | translate }}</span>
                        </div>                
                    }
                </div>        
            
        
        }
    </mat-list>        
    
</div>






  
  